import { render, staticRenderFns } from "./site-row.vue?vue&type=template&id=5134adbe&"
import script from "./site-row.vue?vue&type=script&lang=ts&"
export * from "./site-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports